var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('DistributionOverview'),_c('Transformer'),_c('Monitor'),_c('Events',{on:{"showAlarmPosition":_vm.showAlarmPositionBy}}),_c('EnergyRanking',{attrs:{"areaId":-1}}),_c('SitElectricity')],1)}
var staticRenderFns = []

export { render, staticRenderFns }